const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const handleErrors = async (response, defaultMessage) => {
  if (response.ok) {
    return response.json();
  }
  const body = await response.json().catch(() => ({}));
  throw new Error(body.detail || body.message || defaultMessage || `Request failed (${response.status})`);
};

export async function fetchRatioDefinitions(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      params.set(key, value);
    }
  });
  const response = await fetch(`${API_BASE}/api/ratios/definitions?${params.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Rasyo tanımları alınamadı');
}

export async function createRatioDefinition(data) {
  const response = await fetch(`${API_BASE}/api/ratios/definitions`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify(data)
  });
  return handleErrors(response, 'Rasyo tanımı oluşturulamadı');
}

export async function updateRatioDefinition(id, data) {
  const response = await fetch(`${API_BASE}/api/ratios/definitions/${id}`, {
    method: 'PUT',
    headers: buildHeaders(),
    body: JSON.stringify(data)
  });
  return handleErrors(response, 'Rasyo tanımı güncellenemedi');
}

export async function deactivateRatioDefinition(id) {
  const response = await fetch(`${API_BASE}/api/ratios/definitions/${id}`, {
    method: 'DELETE',
    headers: buildHeaders()
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.detail || body.message || 'Rasyo tanımı pasif edilemedi');
  }
  return null;
}

export async function validateFormula(formula, formData = {}) {
  const payload = {
    ...formData,
    FormulaDsl: formula
  };
  const response = await fetch(`${API_BASE}/api/ratios/definitions/validate`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify(payload)
  });
  return handleErrors(response, 'Formül doğrulaması başarısız');
}

export async function previewRatio(companyId, periodId, formula) {
  const response = await fetch(`${API_BASE}/api/ratios/definitions/preview`, {
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify({
      CompanyId: companyId,
      PeriodId: periodId,
      FormulaDsl: formula
    })
  });
  return handleErrors(response, 'Rasyo önizlemesi alınamadı');
}
